module.exports = __webpack_public_path__ + "static/av-a3c2a310fa3cd9beb25f0853e5c9c4ca.jpg";